export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-eye-line text-white text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold">91黑料吃瓜</span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed mb-4">
              国内领先的吃瓜社区平台，汇聚368万吃瓜群众。提供最全面的91吃瓜福利与91爆料吃瓜内容，是吃瓜群众聚集地和吃瓜福利区的首选平台。
            </p>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 cursor-pointer hover:bg-primary-500 transition-colors">
                <i className="ri-weibo-line text-sm"></i>
              </div>
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 cursor-pointer hover:bg-primary-500 transition-colors">
                <i className="ri-wechat-line text-sm"></i>
              </div>
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 cursor-pointer hover:bg-primary-500 transition-colors">
                <i className="ri-live-line text-sm"></i>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-white text-sm font-bold mb-4">快速导航</h4>
            <div className="space-y-2.5">
              {[
                { label: '话题广场', href: '#topics' },
                { label: '最新动态', href: '#updates' },
                { label: '本周焦点', href: '#carousel' },
                { label: '吃瓜现场', href: '#media' },
                { label: '吃瓜导航', href: '#index' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className="block text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white text-sm font-bold mb-4">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {['91吃瓜群众', '91i吃瓜', '91吃瓜福利', '91爆料吃瓜', '91免费吃瓜', '吃瓜社区'].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1.5 rounded-full bg-white/8 text-foreground-400 text-xs cursor-pointer hover:bg-primary-500 hover:text-white transition-all whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white text-sm font-bold mb-4">合作伙伴</h4>
            <p className="text-foreground-500 text-xs leading-relaxed">
              感谢所有合作伙伴的支持与信任。我们将持续拓展合作，为吃瓜群众提供更丰富的内容和更优质的服务。
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            © 2026 91黑料吃瓜 · 吃瓜群众聚集地。本站内容仅供娱乐参考，请理性吃瓜。
          </p>
          <div className="flex items-center gap-4 text-foreground-500 text-xs">
            <span className="cursor-pointer hover:text-white transition-colors whitespace-nowrap">用户协议</span>
            <span className="cursor-pointer hover:text-white transition-colors whitespace-nowrap">隐私政策</span>
            <span className="cursor-pointer hover:text-white transition-colors whitespace-nowrap">内容声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}